import { render, staticRenderFns } from "./CopyStakeStatsTipsTable.vue?vue&type=template&id=8bc11e70&scoped=true&lang=pug"
import script from "./CopyStakeStatsTipsTable.vue?vue&type=script&lang=ts"
export * from "./CopyStakeStatsTipsTable.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeStatsTipsTable.vue?vue&type=style&index=0&id=8bc11e70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bc11e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSpacer,VTextField})
